export const resolvePath = (obj, path) => {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};
